import React from 'react'
import IconSunFog from '@/components/icons/IconSunFog/IconSunFog'

import IconHandHeart from '@/components/icons/IconHandHeart/IconHandHeart'
import IconSun from '@/components/icons/IconSun/IconSun'
import IconShieldLinear from '@/components/icons/IconShieldLinear/IconShieldLinear'
import IconHeartLinear from '@/components/icons/IconHeartLinear/IconHeartLinear'
import IconMagnifyingGlass from '@/components/icons/IconMagnifyingGlass/IconMagnifyingGlass'

export const resources = [
  {
    title: 'Start Your Journey',
    description:
      'Find out how to start recovery, explore treatments, create support networks, and focus on self-care for mental health and addiction.',
    color: 'bg-amber-100',
    link: '/resources/starting-your-journey-a-guide-to-addiction-and-mental-health-recovery/',
    logo: <IconSunFog className="mx-auto size-14 text-gray-1100" />
  },
  {
    title: 'Support Your Loved One',
    description:
      'Gain insights on how to support loved ones in recovery: offering encouragement, effective communication, and setting healthy boundaries for mutual well-being.',
    color: 'bg-secondary-100',
    link: '/resources/empowering-support-resources-and-strategies-for-loved-ones-in-mental-health-and-addiction-treatment/',
    logo: <IconHeartLinear className="mx-auto size-14 text-gray-1100" />
  },
  {
    title: 'Paying for Treatment',
    description:
      'Addressing cost concerns in addiction, mental health care: Informed decisions on treatment affordability and financing options explained.',
    color: 'bg-gray-200',
    link: '/resources/cost-of-rehab-and-insurance-coverage-faqs/',
    logo: <IconShieldLinear className="mx-auto size-14 text-gray-1100" />
  },
  {
    title: 'Explore Your Options',
    description:
      'Explore diverse recovery options for mental health and addiction: therapy, medication, and holistic methods personalized for healing and wellness.',
    color: 'bg-primary-100',
    link: '/resources/exploring-recovery-your-guide-to-mental-health-and-addiction-support/',
    logo: (
      <IconMagnifyingGlass className="mx-auto size-14 stroke-2 text-gray-1100" />
    )
  },
  {
    title: 'Going to Treatment',
    description:
      'Learn about admissions processes, understand how to request leave from work, and other vital procedures to ensure a smooth transition into your treatment journey.',
    color: 'bg-[#E0F2FF]',
    link: '/resources/prepare-for-healing/',
    logo: <IconHandHeart className="mx-auto size-14 text-gray-1100" />
  },
  {
    title: 'Sustaining Your Recovery',
    description:
      'Learn post-treatment strategies and emphasize aftercare, support systems, and coping skills to ensure lasting recovery and enduring mental well-being.',
    color: 'bg-green-100',
    link: '/resources/how-to-navigate-mental-health-and-addiction-after-treatment/',
    logo: <IconSun className="mx-auto size-14 text-gray-1100" />
  }
]

const ResourceLibrarySection: React.FC = () => {
  return (
    <div className="flex flex-col gap-8">
      <div className="flex w-full flex-col gap-6 text-center">
        <h3 className="mx-auto max-w-[300px] font-FieldsVariable text-2xl font-medium text-gray-1100">
          Get The Help You Need Every Step of The Way
        </h3>
        <h4 className="mx-auto text-lg text-gray-700">
          Clinically reviewed resources to guide you on your recovery journey.
        </h4>
      </div>
      <div className="flex flex-col gap-10">
        <div className="grid grid-cols-1 gap-x-8 gap-y-10 md:grid-cols-2 xl:grid-cols-3">
          {resources.map((resource) => (
            <ResourceCard
              resource={resource}
              key={resource.link}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

const ResourceCard = ({ resource }): JSX.Element => {
  return (
    <a
      className="group flex flex-col justify-start gap-6"
      href={resource.link}
    >
      <div className="relative">
        <div
          className={`flex aspect-video items-center justify-center rounded-xl ${resource.color}`}
        >
          {React.cloneElement(resource.logo as React.ReactElement)}
        </div>
        <div
          className="pointer-events-none absolute inset-0 rounded-xl 
            bg-black/0 transition-colors group-hover:bg-black/[0.03] group-active:bg-black/[0.06]"
        ></div>
      </div>
      <div className="flex flex-col gap-2">
        <p className="text-xl font-medium text-gray-1100 group-hover:underline">
          {resource.title}
        </p>
        <p className="text-sm text-gray-700 ">{resource.description} </p>
      </div>
    </a>
  )
}

export default ResourceLibrarySection
